const SUBSCRIPTION_BASE_PATH = '/manage-subscription';
const SUBSCRIPTION_DEPRECATED_PATH = '/manage-subscription-deprecated';
const JOIN_BASE_PATH = '/join';
const JOIN_DEPRECATED_PATH = '/join-deprecated';

export const ROUTES = {
  getSubscriptionRoutes: () => {
    return {
        manageSubscription: SUBSCRIPTION_BASE_PATH,
        manageSubscription_changePlan: `${SUBSCRIPTION_BASE_PATH}/change-plan`,
    };
  },

  getLegacyRoutes: () => {
    return {
        manageSubscription: SUBSCRIPTION_DEPRECATED_PATH,
    };
  },

  getJoinRoutes: () => {
    return {
        join: JOIN_BASE_PATH,
    };
  },

  getLegacyJoinRoutes: () => {
    return {
        join: JOIN_DEPRECATED_PATH,
    };
  }
};
